export function setSeed(seed) {
  let state = seed;
  
  return function() {
    state = (state * 9301 + 49297) % 233280;
    return state / 233280;
  };
}

export function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function randomChoice(arr) {
  return arr[randomInt(0, arr.length - 1)];
}

export function shuffle(arr) {
  const shuffled = [...arr];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = randomInt(0, i);
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export function randomSample(arr, n, replace = false) {
  if (!replace && n > arr.length) {
    throw new Error('Sample size cannot be larger than array length when replace=false');
  }
  
  if (replace) {
    return Array(n).fill(0).map(() => randomChoice(arr));
  } else {
    const shuffled = shuffle(arr);
    return shuffled.slice(0, n);
  }
}

export function randomNormal(mean = 0, std = 1) {
  let u1 = Math.random();
  let u2 = Math.random();
  
  const z0 = Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);
  return z0 * std + mean;
}

export function randomUniform(min = 0, max = 1) {
  return Math.random() * (max - min) + min;
}
